/** Support: the built-in Support bot, the feedback form and its diagnostics (docs/specs/support.md). */
import { z } from "zod";
import { Id } from "./entities.ts";

export const FeedbackKind = z.enum(["bug", "idea", "question"]);
export type FeedbackKind = z.infer<typeof FeedbackKind>;

/** What the form sends when "Include diagnostics" is ticked. No message content, ids, tokens or file names. */
export const SupportDiagnostics = z.object({
  appVersion: z.string().max(64),
  platform: z.enum(["web", "desktop", "ios", "android"]),
  os: z.string().max(120).optional(),
  browser: z.string().max(120).optional(),
  locale: z.string().max(35),
  timeZone: z.string().max(64).optional(),
  /** Route type only ("channel", "calendar", "settings"), never ids or names. */
  screen: z.string().max(40).optional(),
  connection: z.enum(["online", "connecting", "offline"]).optional(),
});
export type SupportDiagnostics = z.infer<typeof SupportDiagnostics>;

export const SupportRequestInput = z.object({
  kind: FeedbackKind,
  text: z.string().min(10).max(4000),
  /** At most one screenshot, uploaded to the Support DM first (POST /support/dm gives the channel). */
  fileIds: z.array(Id).max(1).optional(),
  diagnostics: SupportDiagnostics.optional(),
});
export type SupportRequestInput = z.infer<typeof SupportRequestInput>;

/** `self`: I sent the same thing in the last 24 h (no new card). `vote`: it matched someone else's open card. */
export const SupportDuplicate = z.enum(["none", "self", "vote"]);
export type SupportDuplicate = z.infer<typeof SupportDuplicate>;

export const SupportRequestResult = z.object({
  messageId: Id,
  channelId: Id,
  duplicate: SupportDuplicate,
});
export type SupportRequestResult = z.infer<typeof SupportRequestResult>;

export const SupportDmResult = z.object({ channelId: Id, userId: Id });
export type SupportDmResult = z.infer<typeof SupportDmResult>;
